import { inspect } from 'util';
import chalk from 'chalk';

const defaultTheme = {
  primary: (str) => chalk.whiteBright(str),
  secondary: (str) => chalk.white(str),
  info: (str) => chalk.green(str),
  warn: (str) => chalk.yellow(str),
  error: (str) => chalk.redBright(str),
  success: (str) => chalk.greenBright(str),
};

let _currentTheme = defaultTheme;
let _defaultColor = 'primary';

function setTheme(theme) {
  _currentTheme = { ...defaultTheme, ...theme };
  return funcs;
}

function print(str) {
  process.stdout.write(str);
}

// maybe rename themed to color()
const themed = (content, color = _defaultColor) => {
  if (!content) return '';
  if (typeof content === 'string')
    return _currentTheme[color] ? _currentTheme[color](content) : _currentTheme[_defaultColor](content);

  // apply limits on returned string from inspected object
  const objString = inspect(content, { colors: true });
  return _currentTheme[color] ? _currentTheme[color](objString) : objString;
};

// console.log passthrough with default coloring
function cl(...contentArgs) {
  console.log(...contentArgs);
  return funcs;
}

function pr(content, color) {
  print(themed(content, color));
  print('\n');
  return funcs;
}

function pp(content, color) {
  print(themed(content, color));
  return funcs;
}

function setDefault(color = 'primary') {
  if (_currentTheme[color]) _defaultColor = color;
  return funcs;
}

const funcs = {
  cl,
  pr,
  pp,
  setTheme,
  setDefault,
};

const printJSON = (data) => {
  console.log(JSON.stringify(data));
};

export { cl, pr, pp, setTheme, setDefault, themed, printJSON };

export default funcs;
